import { useEffect, useState } from "react";
import classes from './GetUsername.module.css';

const GetUsername = (props) => {
  const [gegevens, setGegevens] = useState([]);

  useEffect(() => {
    const fetchGegevens = async () => {
      const response = await fetch(
        `https://www.marchouben.nl/php/inloggegevens-get.php?username=${props.email}`
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      setGegevens(responseData);
    };

    fetchGegevens().catch((error) => {
      console.log(error.message);
    });
  }, [props.email]);

  let gegevensList;

  if (!gegevens) {
    //gegevensList = <li>Geen record gevonden</li>;
    gegevensList = <li className={classes.melding}>Dit email adres is nog niet geregistreerd.</li>;
  } else {
    gegevensList = gegevens.map((gegeven) => (
      <li key={gegeven.id} className={classes.foutmelding}>
        {/*{gegeven.username} <br /> {gegeven.password}*/}
        Dit email adres is reeds geregistreerd. Gebruik een ander adres.
      </li>
    ));
  }

  return <ul>{gegevensList}</ul>;
};

export default GetUsername;
